import type { EventBusPayload } from "@/modules/event-bus";

import { useQueryClient } from "@tanstack/react-query";

import { isNotificationBroadcastInterventionTransitionPayload } from "@/entities/notification-broadcast";
import { useInvalidateNotificationsDatabase } from "@/entities/notifications-database";
import { useGetSettingsNotifications } from "@/entities/settings";
import { useAppNotification } from "@/modules/app-notification";

import { notifyInterventionTransition } from "./intervention-action-transition.helper";

export const useInterventionActionTransition = () => {
  const { notify } = useAppNotification();
  const queryClient = useQueryClient();
  const { invalidateNotifications } = useInvalidateNotificationsDatabase();
  const { isBroadcastNotificationEnabled } = useGetSettingsNotifications();

  const runAction = (payload: EventBusPayload) => {
    if (!isNotificationBroadcastInterventionTransitionPayload(payload)) return;
    if (
      isBroadcastNotificationEnabled(`transition-intervention:${payload.state}`)
    ) {
      notifyInterventionTransition({ notify, payload });
    }
    queryClient.invalidateQueries({
      queryKey: ["interventions"],
    });
    invalidateNotifications("*");
  };

  return { runAction };
};
